<template>
  <div class="maindiv env-wrap bg-gray index_main">
    <div class="list-bg news-bg"></div>
    <div class="bgw tborder">
      <div class="bar-menu htmldiv tcenter fs0 pb40">
        <left v-if="pid >= 0" :pid="pid"/>
          <router-view></router-view>
      </div>
    </div>
    <div class="ht25"></div>
  </div>
</template>

<script>
import Left from "../../components/un_index/Left"
export default {
  name: "index",
  data(){
    return {
      pid:0,
    }
  },
  created() {
    this.updateLeft()
  },
  updated() {
    this.updateLeft()
  },
  methods:{
    updateLeft(){
      this.pid = this.$route.query.pid
    },
  },
  components:{
    Left,
  },

}
</script>

<style scoped>
  .news-bg{background: url(../../assets/images/index_05_01.jpg) no-repeat center top;}
</style>



// WEBPACK FOOTER //
// src/pages/evn/index.vue